import { Ecommerce, Impression } from '../../../types/datalayer/pageview';
import { Details } from '../../../types/ads';

export const getAds = (ads: Details[]): Ecommerce => {
  const e: Ecommerce = {
    currencyCode: 'BRL',
    impressions: [],
  };

  ads?.forEach(a => {
    a.products.forEach((product, i) => {
      const impression: Impression = {
        position: i + 1,
        id: product.id,
        list: '',
      };

      if (a.sponsorName) {
        impression.variant = a.sponsorName;
        impression.list = `ads-branding|${a.type}`;
      }
      impression.list = `ads-${a.title}|${a.type}`;

      e.impressions?.push(impression);
    });
  });

  return e;
};
